import { useMemo } from 'react'

import { CompositeTableTemplate } from 'app/common/templates-next/table-template'
import { ByComplexesAndAllowancesDataItem } from 'app/dataTypes/reports/data/common/ordersByClasses'

import {
  columnKeysLeft,
  columnKeysLeftHeaders,
  columnKeysRight,
  columnKeysRightHeaders,
  createColumnKeysMain,
  createColumnKeysMainHeaders,
  createData,
  createDataProps,
  createHeaderCells,
  createHeaderCellsProps,
  renderTableCell,
} from './table-options'

type Props = {
  dateKeys: Array<string>
  dateKeysFormat: string
  data: Array<ByComplexesAndAllowancesDataItem>
  pending: boolean
}

export const GrouppedByComplexesAndAllowances = ({
  dateKeys,
  dateKeysFormat,
  data,
  pending,
}: Props) => {
  const tableData = useMemo(() => {
    const mainColumnKeys = createColumnKeysMain(dateKeys)
    return {
      columnKeysLeft: columnKeysLeft,
      columnKeysLeftHeaders: columnKeysLeftHeaders,
      columnKeysMain: mainColumnKeys,
      columnKeysMainHeaders: createColumnKeysMainHeaders(dateKeys),
      columnKeysRight: columnKeysRight,
      columnKeysRightHeaders: columnKeysRightHeaders,
      header: createHeaderCells(dateKeysFormat, 'DD.MM'),
      headerProps: createHeaderCellsProps(),
      data: createData(data, mainColumnKeys),
      dataProps: createDataProps(),
    }
  }, [dateKeys, dateKeysFormat, data])

  return (
    <CompositeTableTemplate
      data={tableData}
      loading={pending}
      renderCell={renderTableCell}
      borderTop
    />
  )
}
